export default __webpack_public_path__ + "static/richardto-bd9116859ca735fdbfd7ae9d35f783c2.png";